import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { stack } from '@flipster/styled-system/patterns';

import { rewardHubV2Bunja } from '../state';
import RegularMissions from './regular-missions';
import { SpecialMission } from './regular-missions/single-mission/special-mission';

export const SectionList = () => {
  const { rewardSectionsAtom, specialMissionAtom } = useBunja(rewardHubV2Bunja);
  const rewardSections = useAtomValue(rewardSectionsAtom);
  const specialMissions = useAtomValue(specialMissionAtom);

  return (
    <section className={stack({ gap: { base: 40, smallDesktop: 64 }, px: 16, mt: 32, smallDesktop: { px: 0 } })}>
      {specialMissions.map((mission, i) => (
        <SpecialMission key={`special-mission-${i}`} mission={mission} />
      ))}
      {rewardSections.map((section, i) => (
        <RegularMissions
          key={`regular-mission-${i}`}
          sectionStatus={section.sectionStatus}
          missions={section.regularMissions}
          validityConditions={section.validityConditions}
          sectionDescription={section.sectionDescription}
        />
      ))}
    </section>
  );
};
